module.exports = __webpack_public_path__ + "img/f5e0123.jpg";